import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
  cursor: pointer;

  svg.fa-bars {
    font-size: 1.8em;
    display: flex;
    flex: 1;
  }
`;

export const MenuWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #673490;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  right: ${(props) => (props.burgerMenuActive ? "0vw" : "-100vw")};
  transition: 0.1s ease-in-out;
`;

export const SubNavWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #673490;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: ${(props) => (props.subNavActive ? "0vw" : "-100vw")};
  z-index: 1;
  transition: 0.1s ease-in-out;

  svg.fa-chevron-left {
    padding: 10px;
    position: absolute;
    top: 2px;
    left: 10px;
    color: #fff;
    font-size: 4em;
  }
`;

export const Title = styled.div`
  color: #fff;
  position: absolute;
  top: 18px;
  font-size: 1.4em;
  font-weight: 300;
`;

export const CloseButton = styled.div`
  position: absolute;
  right: 18px;
  top: 10px;
  color: #fff;
  font-size: 2.2em;
`;

export const Links = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: center;
  margin-top: ${(props) => props.iOS && "-50px"};
`;

export const LinkWrapper = styled.a``;

export const LinkItem = styled.li`
  color: #fff;
  padding: ${(props) => (props.iOS ? "10px 0" : "12px 0")};
  font-size: ${(props) => (props.iOS ? "1.6em" : "1.8em")};
  font-weight: 500;
  position: relative;

  &:after {
    content: "";
    position: absolute;
    width: ${(props) => (props.dot ? "12px" : "0px")};
    height: ${(props) => (props.dot ? "12px" : "0px")};
    border-radius: 50%;
    background-color: #f2008c;
  }
`;

export const BetaBadge = styled.div`
  position: absolute;
  right: -35px;
  top: 6px;
  background-color: #f2008c;
  color: #fff;
  font-size: 0.4em;
  border-radius: 25px;
  padding: 2px 5px;
  text-transform: uppercase;
  font-weight: 700;
`;
